<template>
  <div @wheel="wheel" @click="buttonClose">
    <div class="product decstop">
      <div class="product_container container">
        <div class="product__left">
          <p class="product__title" v-html="title"></p>
          <div class="swiper-container product__text_container">
            <div class="swiper-wrapper product__text">
              <div
                class="product__descriptoin_container swiper-slide"
                v-for="text in photos"
                :key="text.id"
              >
                <div
                  class="swiper-container"
                  v-if="text.assortiment.length > 1"
                >
                  <div class="swiper-wrapper">
                    <p
                      class="product__descriptoin swiper-slide"
                      v-for="t in text.assortiment"
                      :key="t.id_m"
                      v-html="t.textProduct"
                    ></p>
                  </div>
                </div>

                <div v-else>
                  <p
                    class="product__descriptoin"
                    v-html="text.assortiment[0].textProduct"
                  ></p>
                </div>
              </div>
            </div>
          </div>
          <p class="product__sub-title"> {{subTitle}} </p>
          <ul class="product__item">
            <li
              class="product__list"
              v-for="(item, index) in items"
              :key="item.id"
            >
              <img :src="item.img" alt />
              <span class="number">{{ index + 1 }}.</span>
              <span v-html="item.text"></span>
            </li>
          </ul>
          <router-link class="arrow" :to="{name: `${langUrl === 'ru' ? btnLink + 'Ru' : btnLink + 'En'}`}">
            <button class="product__btn">{{ btnTitle }}</button>
          </router-link>
        </div>
        <div class="product__right">
          <div class="product__big-photo">
            <div class="swiper-container product_swiper-container">
              <div class="swiper-wrapper product__cart_container">
                <div
                  class="swiper-slide product__cart"
                  v-for="item in photos"
                  :key="item.id"
                >
                  <div
                    class="swiper-container"
                    v-if="item.assortiment.length > 1"
                  >
                    <div class="swiper-wrapper">
                      <div class="button_slide__container">
                        <div
                          class="button_slide button_slide-left"
                          @click="onButtonLeft"
                        ></div>
                        <div
                          class="button_slide button_slide-right"
                          @click="onButtonRight"
                        >
                        </div>
                      </div>
                      <div
                        class="swiper-slide"
                        v-for="i in item.assortiment"
                        :key="i.id_m"
                      >
                        <div class="slideBigImg__conteiner">
                          <img ref="slideBigImg" :src="i.imgProduct" />
                        </div>

                        <div :class="{hide__name_choco: !isVisibilityButton, show__name_choco: isVisibilityButton}">
                          <p class="title" v-html="i.nameProduct"></p>
                          <p class="title_description" v-html="i.flavorProduct"></p>
                        </div>
                      </div>
                      <div class="swiper-pagination"></div>
                    </div>
                  </div>
                  <div v-else>
                    <div class="slideBigImg__conteiner">
                      <img
                          ref="slideBigImg"
                          :src="item.assortiment[0].imgProduct"
                      />
                    </div>
                    <p :class="{hide__name_choco: !isVisibilityButton, show__name_choco: isVisibilityButton}"
                        class="title"
                        v-html="item.assortiment[0].nameProduct"
                    ></p>
                    <p
                        :class="{hide__name_choco: !isVisibilityButton, show__name_choco: isVisibilityButton}"
                        class="title_description"
                        v-html="item.assortiment[0].flavorProduct"
                    >
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="swiper-container gallery-thumbs">
              <div class="arrow-block">
                <div class="arrow-slide arrow-slide_left"></div>
                <div class="arrow-slide arrow-slide_right"></div>
              </div>
              <div class="swiper-wrapper">
                <div
                  class="swiper-slide"
                  v-for="item in photos"
                  :key="item.id"
                  :style="{
                    backgroundImage:
                      'url(' + item.assortiment[0].imgProduct + ')',
                  }"
                ></div>

                <div class="slide-button">
                  <MarketButton/>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="container">
        <router-link
          v-tooltip.right="{
            content: `${arrowTextDown}`,
            class: 'tooltip-arrows',
          }"
          class="arrow"
          :to="{ name: `${langUrl === 'ru' ? arrowsDownLink + 'Ru' : arrowsDownLink + 'En'}` }"
        >
          <img src="@/img/Union.png" alt />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/js/swiper.js";
import {HTTP, Routes} from "../API";
import MarketButton from "@/components/Buttons/MarketButton";

export default {
  name: "PageTwo",
  components: {MarketButton},
  data: () => ({
    page: true,
    title: null,
    descriptoin: null,
    newTitle: null,
    newDescriptoin: null,
    subTitle: null,
    bigSrc: "",
    newBigSrc: "",
    bigPhotoTitle: "",
    bigPhotoDescription: "",
    slideIndex: 0,
    show: true,
    items: [],
    photos: [],
    arrowsDown: null,
    arrowTextDown: null,
    btnTitle: "",
    btnLink: "",
    productSwiperContainerNext: null,
    productTextContainerNext: null,
    sortScreenUp: null,
    sortScreenDown: null,
    arrowsDownLink: null,
  }),
  mounted: function() {
    this.getContent();
  },
  props: {
    lang: { type: String },
    sortScreen: {type: Array},
    langUrl: {type: String}
  },
  watch: {
    lang: function(newValue, oldValue) {
      this.getContent();
    },
  },
  computed: {
    isVisibilityButton() {
      return this.$store.state.button.isCloseButton
    }
  },
  methods: {
    buttonClose() {
      if (this.isVisibilityButton === false) {
        this.$store.dispatch('buttonAction', true)
      }
    },
    // isTransferData(event) {
    //   this.ISSHOW = event
    // },
    getContent() {
      HTTP.get(Routes.two).then((response) => {
        this.subTitle = response.data[this.lang].cookingMethodTitle;
        this.items = response.data[this.lang].cookingMethod;
        this.photos = response.data[this.lang].productDesk;
        let btn = response.data[this.lang].btnUpScreen;
        this.btnLink = btn.btnUpScreenUrl;
        this.btnTitle = btn.btnUpScreenTitle;
        this.title = response.data[this.lang].headProduct;

        setTimeout(() => {
          var productTextContainer = new Swiper(".product__text_container", {
            slidesPerView: 1,
            speed: 350,
            // loop: true,
            effect: "fade",
            direction: "horizontal",
            allowTouchMove: false,
            watchOverflow: true,
          });

          this.productSwiperContainerNext = new Swiper(
              ".product_swiper-container .swiper-container",
              {
                slidesPerView: 1,
                speed: 350,
                loop: true,
                effect: "fade",
                direction: "horizontal",
                watchOverflow: true,
                allowTouchMove: false,
                pagination: {
                  el: ".product_swiper-container .swiper-pagination",
                  type: "bullets",
                },
              }
          );

          this.productTextContainerNext = new Swiper(
              ".product__text_container .swiper-container",
              {
                slidesPerView: 1,
                speed: 350,
                loop: true,
                effect: "fade",
                direction: "horizontal",
                watchOverflow: true,
                allowTouchMove: false,
              }
          );

          var recipesSwiper = new Swiper(".product_swiper-container", {
            slidesPerView: 1,
            // loop: true,
            // autoHeight: true,
            speed: 350,
            effect: "fade",
            direction: "horizontal",

            allowTouchMove: false,
            watchOverflow: true,
            thumbs: {
              swiper: productTextContainer,
            },
          });

          var galleryThumbs = new Swiper(".gallery-thumbs", {
            spaceBetween: 10,
            slidesPerView: 4,
            centeredSlides: true,
            touchRatio: 0.2,
            slideToClickedSlide: true,
            navigation: {
              nextEl: ".arrow-slide_right",
              prevEl: ".arrow-slide_left",
            },
            thumbs: {
              swiper: recipesSwiper,
            },
          });
        }, 0);
      });
      HTTP.get(Routes.arrows).then((response) => {
        this.arrowsDown = response.data[this.lang].down[1];
        this.arrowTextDown = this.arrowsDown.downText;
        this.arrowsDownLink = this.arrowsDown.downTextUrl
      });
    },
    wheel(ev) {
      this.sortScreenUp = this.sortScreen[2].SCROL_UP ? this.sortScreen[2].SCROL_UP : '';
      this.sortScreenDown = this.sortScreen[2].SCROL_DW ? this.sortScreen[2].SCROL_DW : '';
      if (ev.deltaY > 0) {
        setTimeout(() => {
          if (this.$router.history.current.path !== `/${this.langUrl}/${this.sortScreenDown}`) {
            this.$router.push(`/${this.langUrl}/${this.sortScreenDown}`);
          }
        }, 0);
      }
      if (ev.deltaY < 0) {
        setTimeout(() => {
          if (this.$router.history.current.path !== `/${this.langUrl}/${this.sortScreenUp}`) {
            this.$router.push(`/${this.langUrl}/${this.sortScreenUp}`);

          }
        }, 0);
      }
    },
    onButtonLeft() {
      this.productSwiperContainerNext.slidePrev();
      this.productTextContainerNext.slidePrev();
      this.$store.dispatch('buttonAction', false)
    },
    onButtonRight() {
      this.productSwiperContainerNext.slideNext();
      this.productTextContainerNext.slideNext();
      this.$store.dispatch('buttonAction', false)
    },
  },
};
</script>
